<template>
    <footer class="footer-wrapper">
        <img src="@/assets/images/img_footer.png" class="logo" alt="">
        <a href="" @click.prevent="openNewWindow('https://redcandlegames.com/?utm_source=ebg_2020detention&utm_medium=schoolmagazine&utm_campaign=2020detention');gaEvent(gaCategory, 'redcandle_link');" class="link right"></a>
        <a href="" @click.prevent="openNewWindow('https://uevent.udnfunlife.com/?utm_source=ebg_2020detention&utm_medium=schoolmagazine&utm_campaign=2020detention');gaEvent(gaCategory, 'udn_link');" class="link left"></a>
    </footer>
</template>
<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    data() {
        return {
            gaCategory: 'footer_bt',
        };
    },
    methods: {
        openNewWindow(url) {
            window.open(url, 'blank');
        },
    },
    mixins: [mixinMethod],
};

</script>
